// extracted by mini-css-extract-plugin
export default {"cameraRoot":"PicFromFileOrCam_cameraRoot__5wzOl","cameraCloseButton":"PicFromFileOrCam_cameraCloseButton__6KGu4"};